import React from 'react';
import { icons } from '../../../../assets';
import { ButtonColors, Button } from '../../../components';
import './navigation.scss';

export const Navigation = ({strings, handleGiveUp, allowPrevStep, allowNextStep, handleChangeStep}) => {
  const handlePrevStep = () => {
    if(allowPrevStep) {
      handleChangeStep(-1)
    }
  };
  const handleNextStep = () => {
    if(allowNextStep) {
      handleChangeStep(+1)
    }
  };
    return (
        <div id={'sideNavigation'}>
            <div className={'actions'}>
                <Button
                    color={ButtonColors.grey}
                    label={strings('give_up')}
                    className={'give-up'}
                    icon={icons.CLOSE}
                    action={handleGiveUp}
                />
            </div>
            <div className={'step-navigation'}>
                <i className={`material-icons ${allowPrevStep ? '' : 'disabled'}`} onClick={handlePrevStep}>{icons.ARROW_BACK}</i>
                <div className={'vl'}/>
                <i className={`material-icons ${allowNextStep ? '' : 'disabled'}`} onClick={handleNextStep}>{icons.ARROW_FORWARD}</i>
            </div>
        </div>
    );
};
